// firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

import config from '../../config.json';

const firebaseConfig = {
  apiKey: config.apiKey,
  authDomain: config.authDomain,
  databaseURL: config.databaseURL,
  projectId: config.projectId,
  storageBucket: config.storageBucket,
  messagingSenderId: config.messagingSenderId,
  appId: config.appId,
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const getMessagingToken = async () => {
  try {
    const token = await getToken(messaging, { vapidKey: config.vapidKey });
    return token;
  } catch (error) {
    console.error(`Failed to get firebase messaging token: ${error.message}`);
    return null;
  }
};

const subscribers = [];

export const subscribe = (cb) => {
  subscribers.push(cb);

  return () => {
    const cbIndex = subscribers.findIndex((item) => item === cb);
    subscribers.splice(cbIndex, 1);
  };
};

onMessage(messaging, (payload) => {
  subscribers.forEach((cb) => cb(payload.data));
});

export default {
  messaging,
};
